import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Vanbannhanuoc from "components/Danhsachvanban/Vanbannhanuoc/Quanlyvanban.js";
import Vanbansogtvt from "components/Danhsachvanban/Vanbansogtvt/Quanlyvanban.js";
export default function QLvanban() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Văn bản Quản lý nhà nước",
            tabContent: <Vanbannhanuoc />,
          },
          {
            tabName: "Văn bản Sở Xây dựng",
            tabContent: <Vanbansogtvt />,
          },
        ]}
      />
    </div>
  );
}
